export const ENVIRONMENT = {
  production: false,
  MIXPANEL: {
    token: '685fa973ee0592d7a12d4a338fbc2eab',
    configuration: { debug: true, track_pageview: false, persistence: 'localStorage' },
    environment: 'HOM',
    platform: 'couriers-portal',
  },
  GOOGLE_MAPS: {
    API_KEY: 'AIzaSyAmU1a5cP16ugUGMO3fTx3HxIYWH-wVWcI',
    MAP_STYLES_ID: '8e0057f40524aa5dfa116c8e',
  },
  CARRIERS_INTEGRATION_SERVICE: {
    HOST_NAME: 'http://carrier-integration-service:8080',
  },
};
